// Lib
import { SIZE_50 } from '@/lib/gridElements/size';
import { TWITTER } from '@/lib/socialProfile';
import { classicFormat } from '@/utils/hooks/format/useFormatNumber';

// Components
import { SimpleBarChart } from '@/components/composite/Charts/SimpleBarChart';

export const avgEngagementPerTweetTypeConfig = {
    title: 'chart.twitter.avg_engagements_tweet_type',
    tooltip: 'chart.twitter.tooltip_avg_engagements_tweet_type',
    id: 'average_engagement_per_tweet_type',
    noLegend: true,
    tickFormatterTranslation: 'analytics:chart.post_type_twitter',
    tableColumnFormatterTranslation: 'analytics:chart.post_type_twitter',
    margin: {
        left: -40
    },
    name: {
        type: 'chart.twitter.avg_engagements_tweet_type_type',
        value: 'chart.twitter.avg_engagements_tweet_type_value'
    },
    social: TWITTER,
    valueFormat: classicFormat,
    color: {
        value: 'green'
    },
    size: SIZE_50,
    type: 'chart',
    element: SimpleBarChart
};
